export interface EndScreenProps {
  transferred: number;
  queued: number;
  failed: number;
}

/** Abschlussseite after the session ended (staff ended the room or the
 * customer tapped „Beenden"). */
export function EndScreen({ transferred, queued, failed }: EndScreenProps): JSX.Element {
  return (
    <div className="end-screen">
      <span className="brand">
        Fast<span className="brand-accent">garage</span>
      </span>
      <div className="end-check" aria-hidden="true">
        ✓
      </div>
      <h1>Vielen Dank!</h1>
      <p className="end-count">
        {transferred === 1 ? '1 Foto wurde übertragen.' : `${transferred} Fotos wurden übertragen.`}
      </p>
      {queued > 0 ? (
        <p className="end-queued">
          {queued === 1
            ? '1 Foto wird noch übertragen — bitte lassen Sie diese Seite kurz geöffnet.'
            : `${queued} Fotos werden noch übertragen — bitte lassen Sie diese Seite kurz geöffnet.`}
        </p>
      ) : (
        <p className="end-note">Sie können dieses Fenster jetzt schließen.</p>
      )}
      {failed > 0 && (
        <p className="end-queued">
          {failed === 1
            ? '1 Foto konnte nicht mehr übertragen werden, da der Termin bereits beendet war.'
            : `${failed} Fotos konnten nicht mehr übertragen werden, da der Termin bereits beendet war.`}
        </p>
      )}
      <p className="end-footer">Fastgarage — Video-Schadenaufnahme</p>
    </div>
  );
}
